import { empresaObj } from './../shared/Util';
import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { ControlStatusService } from '../shared/control-status.service';
import { Util } from '../shared/Util';
import { HttpClient } from '@angular/common/http';
import { CurrencyPipe } from '@angular/common';
import { JsonReturn, ObjectParam } from '../shared/interface/generic-interface';

@Injectable()
export class DashboardService {
  toggleMovimentacaoDia: boolean = false;
  dataVisualizacao: string = '';
  constructor(private conService: ApiConService, private controlStatus: ControlStatusService, private util: Util, private currencyPipe: CurrencyPipe
  ) { }

  nuRotAtualizaCoordenadas: number = undefined;
  exibirModalAvaliacao: boolean = false;


  criarObjParamRoteiro(): ObjectParam {
    return {
      filtroRoteiro: {
        dtPrevisoSaida: this.dataVisualizacao,
        movDia: this.toggleMovimentacaoDia
      }
    };
  }

  async getRoteiros(objParam) {
    try {
      let response: JsonReturn = await this.conService.patchBodyRoteiro('DCroteiros', objParam);
      return response.response;
    } catch (Error) {
      console.log(Error);
    }
  }

  async getRoteirosPorEmpresa(cdEmp: number) {
    try {
      let response: JsonReturn = await this.conService.patch(`DCroteiros/porEmpresa:/${cdEmp}`);
      return response.response;
    } catch (Error) {
      console.log(Error);
    }
  }


  async getTotalClientes(objParam) {
    try {
      let response: JsonReturn = await this.conService.patchBodyRoteiro('DCroteiros/dashboard/totalClientes', objParam);
      return response.response;
    } catch (Error) {
      console.log(Error);
    }
  }

  async getTotalRoteiro(numeroRoteiro) {
    try {
      let response: JsonReturn = await this.conService.patch(`DCroteiros/dashboard/totalRoteiro/${numeroRoteiro}`);
      return response.response;
    } catch (Error) {
      console.log(Error);
    }
  }

  async getTotalOcorrencias() {
    try {
      let response: JsonReturn = await this.conService.patch('DCocorrencias/dashboard/totalOcorrencias');
      return response.response;
    } catch (Error) {
      console.log(Error);
    }
  }

  async getRelatoriosDistancia(data, dataFinal) {
    let relatorios = [];
    let rows = [];

    try {
      let response: JsonReturn = await this.conService.patch('DCrelatorios/data/' + data + '/' + dataFinal);

      relatorios = response.response;

      relatorios.filter(x => {
        let cdEmp = x.cdEmp;
        let nomeFantasia = x.NomeFantasia;
        let roteiro = x.NumeroRoteiro;
        let cliente = x.CodigoCLiente;
        let razaoSocial = x.RazaoSocial;
        let latCadastro = `${x.latitudeCadastro.replace(".", ",")}`;
        let longCadastro = `${x.longitudeCadastro.replace(".", ",")}`;
        let latEntrega = `${x.latitudeEntrega.replace(".", ",")}`;
        let LongEntrega = `${x.longitudeEntrega.replace(".", ",")}`;
        let distancia = x.distanciaMetros >= 1000 ? `${x.distanciaMetros / 1000} km` : `${x.distanciaMetros} m`;
        let endereco = `${x.Endereco}, ${x.Numero} - ${x.Bairro}/${x.Cidade} - CEP:${x.Cep}`;
        let data = x.dataFinalEntrega;
        let nomeMotorista = x.NomeMotorista;
        let houveOcorrencia = x.houveOcorrencia;
        let tempoEntrega = x.tempoEntrega
        let numeroPedido = x.Pedidos;
        let nf = x.Notas;
        let valorNFs = x.ValorNFs;
        let valorTotal = x.ValorTotal
        let peso = x.Peso.toFixed(2).replace('.', ',')
        rows.push([cdEmp, nomeFantasia, roteiro, cliente, razaoSocial, latCadastro, longCadastro, latEntrega, LongEntrega, distancia, endereco, data, nomeMotorista, houveOcorrencia, tempoEntrega, numeroPedido, nf, valorNFs, valorTotal, peso]);
      });
      // Seleciona os roteiros dentro da requisição
      let roteirosPorData = []
      rows.forEach(x => {
        let roteiro = x[2] || '';
        roteirosPorData.push(roteiro)
      })
      // Filtra os roteiros repetidos, criando um array com os roteiros do relatorio pedido
      let roteirosPorDataFiltrado = roteirosPorData.filter((item, pos) => {
        return roteirosPorData.indexOf(item) === pos
      })
      //  Cria o array dos roteiros planejados seguindo a ordem do roteirizador do Rotaplan
      let ordemRecebida = []
      let rotasPlanejadas = []
      for (let roteiro of roteirosPorDataFiltrado) {
        console.log(roteiro);

        ordemRecebida = await this.getOrdemPlanejadaDeEntrega(roteiro)
        ordemRecebida.forEach(x => {
          let idRoteiroPedido = x[0] || '';
          let roteiroRecebido = x[1] || '';
          let codigoCliente = x[2] || '';
          let indice = x[3] || '';
          rotasPlanejadas.push([idRoteiroPedido, roteiroRecebido, codigoCliente, indice])
        })
      }

      let roteiroPorCliente = []
      rows.forEach(x => {
        let cliente = x[1] || ''
        roteiroPorCliente.push(cliente)
      })
      //Função para a ordenação de array das rotas roteirizadas de acordo com a ordem de entrega real.
      let rotasOrdenadasPorCliente = []

      roteiroPorCliente.forEach((ordemReal) => {
        rotasPlanejadas.map((x) => {
          if (x[2] == ordemReal) {
            rotasOrdenadasPorCliente.push(x[x.length - 1])
          };

        });
        return rotasOrdenadasPorCliente
      })

      //Adiciona o indice das rotas planejadas ao array que será enviado quando o metodo for chamado
      let rowsComIndice = []
      rows.forEach(x => {
        x.push(rotasOrdenadasPorCliente[rowsComIndice.length])
        rowsComIndice.push(x)
      }
      )


      relatorios = [];
      relatorios = rowsComIndice;

      return relatorios;
    }
    catch (Error) {
      console.log(Error);
      return Error;
    }
  }

  async getRelatoriosOcorrencia(data, dataFinal) {
    try {
      let response: JsonReturn = await this.conService.patch('DCrelatorios/ocorrencia/' + data + '/' + dataFinal);
      return response.response;
    } catch (Error) {
      return Error;
    }
  }

  async getRelatoriosMotorista(data, dataFinal) {
    let relatorios = [];
    let rows = [];

    try {
      let response: JsonReturn = await this.conService.patch('DCrelatorios/motorista/' + data + '/' + dataFinal);

      relatorios = response.response;

      relatorios.filter(x => {
        let motorista = x.nome_motorista;
        let roteiro = x.roteiro;
        let data = x.Data;
        let distPlanejada = x.distanciaPlanejada;
        let distPercorrida = x.distanciaPercorrida;
        let entregas = x.QtdeEntregas;
        let realizadas = x.realizadas;
        let ocorrencia = x.ocorrencias;
        let inicioTrabalho = x.inicioTrabalho;
        let finalTrabalho = x.finalTrabalho;
        let tempoTotal = x.tempoTotal;
        rows.push([motorista, roteiro, data, distPlanejada, distPercorrida, entregas, realizadas, ocorrencia, inicioTrabalho, finalTrabalho, tempoTotal]);
      });

      relatorios = [];
      relatorios = rows;

      return relatorios;
    }
    catch (Error) {
      console.log(Error);
      return Error;
    }
  }

  async getMotoristasOcorrencias(data, dataFinal) {
    let relatorios: any

    try {
      relatorios = await this.conService.patch('DCrelatorios/motoristasOcorrencias/' + data + '/' + dataFinal);

      return relatorios;
    }
    catch (Error) {
      console.log(Error);
      return Error;
    }
  }

  async getOcorrenciasDetalhes(data, dataFinal) {
    let relatorios = [];
    let rows = [];

    try {
      let response: JsonReturn = await this.conService.patch('DCrelatorios/ocorrenciasDetalhes/' + data + '/' + dataFinal);
      relatorios = response.response;
      relatorios.filter(x => {
        let codigoOcorrencia = x.CodigoOcorrencia;
        let numeroRoteiro = x.NumeroRoteiro;
        let data = new Date(x.Data).toLocaleDateString();
        let nomeMotorista = x.NomeMotorista;
        let codigoCliente = x.CodigoCliente;
        let nomeFantasia = x.NomeFantasia;
        let motivo = x.Motivo;
        let mensagem = this.util.verificaMensagem(x.Mensagem) || "";
        rows.push([data, numeroRoteiro, codigoOcorrencia, nomeMotorista, codigoCliente, nomeFantasia, motivo, mensagem]);

      })
      return rows;
    }
    catch (Error) {
      console.log(Error);
      return Error;
    }
  }

  async deleteRoteiro(NumeroRoteiro) {
    try {
      let response = await this.conService.patch(`DCroteiros/del/${NumeroRoteiro}`);
      return response.response;
    } catch (Error) {
      console.log(Error);
    }
  }

  async finalizarRoteiro(idRoteiro) {
    try {
      let response = await this.conService.patch(`DCroteiros/roteiro/encerrarRadarMotorista/${idRoteiro}`);
      return response.response;
    } catch (Error) {
      console.log(Error);
    }
  }

  async getSituacaoRoteiro(numeroRoteiro) {
    try {
      let response: JsonReturn = await this.conService.patch('DCroteiros/dashboard/situacaoRoteiro/' + numeroRoteiro);
      return response.response;
    } catch (error) {
      this.controlStatus.msgErroBusca = "Ocorreu um erro ao buscar o roteiro.";
      console.log(error);
    }
  }

  //Metodo que faz a requisição ao backend dos roteiros de entrega de acordo com a ordem feita pelo roteirizador do
  //Rotaplan
  async getOrdemPlanejadaDeEntrega(numeroRoteiro: any) {
    let ordem = [];
    let rows = [];
    let indice = 0
    try {

      let response: JsonReturn = await this.conService.patch('DCrelatorios/ordemPlanejada/' + numeroRoteiro);
      ordem = response.response
      ordem.filter(x => {
        let idRoteiroPedido = x.IdRoteiroPedido;
        let numeroRoteiro = x.NumeroRoteiro
        let codigoCliente = x.CodigoCliente
        rows.push([idRoteiroPedido, numeroRoteiro, codigoCliente])
      });
      //Filtra dos predidos recebidos do roteiro os clientes em duplicata. Retornando um array com apenas um dos itens.
      let ordemFiltrada = rows.filter(([id, rot, cod], i) => {
        return !rows.some(
          ([_id, _rot, _cod], j) => j > i && cod === _cod);
      });
      // Cria o array das rotas planejadas com o indice das rotas de acordo com o roteirizador do Rotaplan
      let indiceRotasPlanejadas = 0
      let rotasPlanejada = [];
      ordemFiltrada.forEach(x => {
        let idRoteiroPedido = x[0] || '';
        let roteiro = x[1] || '';
        let codigoCliente = x[2] || '';
        indiceRotasPlanejadas++
        rotasPlanejada.push([idRoteiroPedido, roteiro, codigoCliente, indiceRotasPlanejadas])
      })


      return rotasPlanejada;
    }
    catch (Error) {
      console.log(Error);
      return Error;
    }
  }

  async intervaloEntregaPorCliente(data, dataFinal) {
    let relatorios = [];
    let rows = [];

    try {
      let response: JsonReturn = await this.conService.patch('DCrelatorios/intervaloEntregaPorCliente/' + data + '/' + dataFinal);
      relatorios = response.response;
      relatorios.filter(x => {

        let dataUTC = x.DtChegada.replace('Z', '');
        let cdEmp = x.cdEmp;
        let empOrigem = x.EmpresaOrigem;
        let numeroRoteiro = x.NumeroRoteiro;
        let nomeMotorista = x.NomeMotorista;
        let codigoCliente = x.CodigoCliente;
        let nomeFantasia = x.NomeFantasia
        let dtChegada = new Date(dataUTC).toLocaleDateString();
        let horaChegada = x.HoraChegada;
        let inicioEntrega = x.InicioEntrega;
        let fimEntrega = x.FimEntrega;
        let intervaloEntrega = x.IntervaloEntrega;
        let qtdePedidos = x.QtdePedidos;
        let numeroPedido = x.Pedidos;
        let nf = x.Notas;
        let valorNFs = x.ValorNFs;
        let valorTotal = x.ValorTotal
        let peso = x.Peso.toFixed(2).replace('.', ',')
        rows.push([cdEmp, empOrigem, numeroRoteiro, nomeMotorista, codigoCliente, nomeFantasia, dtChegada, horaChegada, inicioEntrega, fimEntrega, intervaloEntrega, qtdePedidos, numeroPedido, nf, valorNFs, valorTotal, peso]);

      })
      return rows;
    }
    catch (Error) {
      console.log(Error, 'Relatório intervaloEntregaPorCliente');
      return Error;
    }
  }

  async jornadaTrabalhoMotorista(data, dataFinal) {
    let relatorios = [];
    let rows = [];

    try {
      let response: JsonReturn = await this.conService.patch('DCrelatorios/jornadaTrabalhoMotorista/' + data + '/' + dataFinal);
      relatorios = response.response;
      relatorios.filter(info => {

        let motorista = info.NomeMotorista;
        let diasTrabalhados = info.DiasTrabalhados;
        let totalDeHoras = info.TotalHoras;
        let mediaHoraDia = info.MediaHoras;
        let totalDePausa = info.TotalPausa;
        let kmRodado = info.TotalKm ? info.TotalKm : '';
        let totalRoteiro = info.TotalRoteiros;
        let totalPedidos = info.TotalEntregas[0];
        let totalVlPedidos = this.currencyPipe.transform(info.TotalValores, 'BRL', true)

        rows.push([motorista, diasTrabalhados, totalDeHoras, mediaHoraDia, totalDePausa, kmRodado, totalRoteiro, totalPedidos, totalVlPedidos]);

      })
      return rows;
    }
    catch (Error) {
      console.log(Error, 'Relatório jornadaTrabalhoMotorista');
      return Error;
    }
  }

  async formaDePagamento(data, dataFinal) {
    let relatorios = [];
    let rows = [];

    try {
      let response: JsonReturn = await this.conService.patch('DCrelatorios/formaDePagamento/' + data + '/' + dataFinal);
      relatorios = response.response;
      relatorios.filter(info => {

        let numeroRoteiro = info.NumeroRoteiro;
        let numeroPedido = info.NumeroPedido;
        let formaPagamentoOrigin = info.FormaPagamento;
        let formaPagamentoEfetuada = info.FormaPagamentoEfetuada || '';
        let valorPedido = this.currencyPipe.transform(info.ValorPedido, 'BRL', true);
        let nomeMotorista = info.NomeMotorista;
        let dataPedido = new Date(info.DataPedido).toLocaleDateString();
        let situacaoPedido = this.util.DescricaoStatusEntrega(info.IdRoteiroPedidoSituacao);

        rows.push([numeroRoteiro, numeroPedido, formaPagamentoOrigin, formaPagamentoEfetuada, valorPedido, nomeMotorista, dataPedido, situacaoPedido]);

      })
      return rows;
    }
    catch (Error) {
      console.log(Error, 'Relatório forma de pagamento');
      return Error;
    }
  }

  //Metoro para receber as empresas filiais do Backend
  async getEmpresas() {
    try {
      let empresas: JsonReturn = await this.conService.patch('DCEmpresa')

      this.util.cnpjEmpresas = [];

      empresas.response.forEach(empresa => {
        this.util.cnpjEmpresas.push(empresa.cnpj)
      });

      return empresas.response;
    }
    catch (error) {
      console.error(' Não foi possivel requisitar nenhuma empresa ou filial')
      console.log(error);

    }
  }

  async getEmpresasJasper() {
    try {
      let empresa: JsonReturn = await this.conService.patch('DCEmpresa/jasper')
      return empresa.response
    } catch (error) {
      console.error(' Não foi possivel requisitar nenhuma empresa ou filial')
      console.log(error);
    }

  }



  async getVersaoAtualAplicativo() {
    return await this.conService.patch('DCVersoesApp/retaguarda')
  }

  async getVersaoTranspAplicativo() {
    return await this.conService.patch('DCVersoesAppTransp')
  }


  async getConsumoDt() {
    const date = new Date();
    const primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleString();
    const ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleString();

    const editPrimeroDia = `${primeiroDia.substring(6, 10)}-${primeiroDia.substring(3, 5)}-${primeiroDia.substring(0, 2)}`;
    const editUltimoDia = `${ultimoDia.substring(6, 10)}-${ultimoDia.substring(3, 5)}-${ultimoDia.substring(0, 2)}`;

    return await this.conService.patch(`DCConfiguracaoGeral/checkUsoPeriodo/${editPrimeroDia}/${editUltimoDia}`)
  }

  async ultimasEntregas() {
    try {
      let response: JsonReturn = await this.conService.patch('DCroteiros/ultimasEntregas');
      return response.response;
    } catch (Error) {
      console.log(Error);
    }
  }
}

